'use client';
import Typography from '@/components/shared/typography/typography.component';
import {
    GrayArrow,
    GreenCalendar,
    LocationPin,
    MapBlue,
} from '../../../../../public/Images';
import Image from 'next/image';
import styles from './styles.module.scss';
import Link from '@/components/WrappedLink';
import { sylndrDirections } from '@/constants';
import colors from '@/theme/colors.module.scss';
import { useTranslation } from 'react-i18next';

const SylndrWorkingHoursLocation = ({
    showGetDirections = false,
}: {
    showGetDirections?: boolean;
}) => {
    const { t, i18n } = useTranslation();
    const IS_RTL = i18n.language === 'ar';

    return (
        <div className={styles.container}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                    width: '100%',
                }}
            >
                <div className={styles.info_container}>
                    <Image
                        src={LocationPin.src}
                        width={16}
                        height={16}
                        alt="working hours"
                    />
                    <div style={{ width: '100%' }}>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                width: '100%',
                            }}
                        >
                            <Typography
                                variant="body1Medium"
                                color={colors.primary}
                            >
                                {t('sylndrHubTitle')}
                            </Typography>
                            <div className={styles.mobile_container}>
                                <Link
                                    prefetch={false}
                                    className={styles.get_directions}
                                    href={sylndrDirections}
                                    target="_blank"
                                >
                                    <Typography
                                        component="span"
                                        color={colors.gray500}
                                        variant="body1Medium"
                                    >
                                        {t('directions')}
                                    </Typography>
                                    <Image
                                        style={{
                                            transform: IS_RTL
                                                ? 'scaleX(-1)'
                                                : '',
                                        }}
                                        src={GrayArrow.src}
                                        width={10}
                                        height={10}
                                        alt="get directions"
                                    />
                                </Link>
                            </div>
                        </div>
                        <Typography variant="body1" color={colors.gray500}>
                            {t('mainShowroomAddress')}
                        </Typography>
                    </div>
                </div>

                <div className={styles.info_container}>
                    <Image
                        src={GreenCalendar.src}
                        width={16}
                        height={16}
                        alt="location"
                    />
                    <div>
                        <Typography
                            variant="body1Medium"
                            color={colors.primary}
                        >
                            {t('workingHoursTitle')}
                        </Typography>
                        <Typography variant="body1" color={colors.gray500}>
                            {t('workingHoursValue')}
                        </Typography>
                    </div>
                </div>
            </div>
            <div className={styles.desktop_container}>
                {showGetDirections && (
                    <Link
                        prefetch={false}
                        className={styles.get_directions}
                        href={sylndrDirections}
                        target="_blank"
                    >
                        <Image
                            src={MapBlue.src}
                            width={20}
                            height={20}
                            alt="get directions"
                        />
                        <Typography
                            component="span"
                            style={{
                                textDecoration: 'underline',
                                height: '16px',
                            }}
                            color={colors.secondary500}
                            variant="body1Medium"
                        >
                            {t('directions')}
                        </Typography>
                    </Link>
                )}
            </div>
        </div>
    );
};
export default SylndrWorkingHoursLocation;
